import {
    api,
    urls
} from '../../../_common/scripts/api';
import handorgel from "handorgel";
import functions from '../../../_common/scripts/functions';
import validator from "../../../_common/scripts/validator";
import Modal from "../../../_common/scripts/modal";

var groups, modalTable, modalError;

const generateTable = data => {
    let tbody = document.getElementById("modal-tbody");
    functions.clearElements(tbody);

    data.map(element => {
        let tr = functions.elementCreater("tr");

        tr.appendChild(functions.elementCreater("td", element.group));
        tr.appendChild(functions.elementCreater("td", element.order));
        tr.appendChild(functions.elementCreater("td", element.modality));
        tr.appendChild(functions.elementCreater("td", element.cts_lic));

        tbody.appendChild(tr);
    });
};

document.getElementById('accordion-one').onclick = function(event){
    event.preventDefault();
    this.classList.toggle("handorgel__header--open");
    document.getElementsByClassName('accordion-item-one')[0].classList.toggle("open-content");
}

document.getElementById('accordion-two').onclick = function(event){
    event.preventDefault();
    this.classList.toggle("handorgel__header--open");
    document.getElementsByClassName('accordion-item-two')[0].classList.toggle("open-content");
}

const queryAct = event => {
    let act = document.getElementById("act-select").value;
    let group = document.getElementById("group-number").value.trim();

    if (act != "") {
        api().clients().getAct(act, group, function (data) {
            if (data.length > 0) {
                generateTable(data);
                modalTable.open(event);
            } else {
                modalError.open(event);
            }
        });
    }
};

const queryGroup = event => {
    let node = document.getElementById("group-select");

    if (validator.validateSingle(node)) {
        let item = groups.find(element => element.value == node.value);

        if (item != null && item.url != null && item.url !== "") {
            var anchor = document.getElementById("link-helper");
            anchor.href = item.url;
            anchor.target = "_blank";

            anchor.click();
        } else {
            modalError.open(event);
        }
    }
};

const addListeners = () => {
    document
        .getElementById("query-button-act")
        .addEventListener("click", queryAct);
    document
        .getElementById("query-button-group")
        .addEventListener("click", queryGroup);
    document
        .getElementById("group-number")
        .addEventListener("keydown", functions.allowOnlyNumbers);
    document
        .getElementById("group-number")
        .addEventListener("blur", functions.changeIfNumbers);

    let elements = document.getElementsByClassName("required-select-node");

    for (let i = 0; i < elements.length; i++) {
        elements[i].addEventListener("change", () => {
            validator.validateSingle(elements[i]);
        });
    }
};

const run = () => {
    //createHandorgel();
    addListeners();

    modalTable = new Modal("table-modal", {
        transition: false
    });
    modalTable.init();

    modalError = new Modal("error-modal", {
        transition: false
    });
    modalError.init();

    api().clients().getActs(function (data) {
        functions.addOptions(
            data,
            document.getElementById("act-select"),
            "Nueva búsqueda"
        );
    });

    api().clients().getGroups(function (data) {
        groups = data;
        functions.addOptions(
            data,
            document.getElementById("group-select"),
            "Nueva búsqueda"
        );
    });

    api().clients().getNexts(function (data) {
        let info = [];
        info.push(["Próximo acto: " + data.ProximoActo + " en Chevrolet, " + data.DireccionActo + "."]);
        info.push(["Horarios: Cierre de recepción de ofertas: " + data.CierreRecepcion + " Hs / Apertura de la Urna: " + data.AperturaUrna + " Hs / Sorteo General: " + data.SorteoGeneral + " Hs / Lectura de resultados: " + data.LecturaResultados + " Hs"]);

        const container = document.getElementById("resultados-actos-adjudicacion");
        const listsContainer = functions.elementCreater("div", "", {
            class: "lists-container"
        });

        for (let i = 0; i < info.length; i++) {
            let list = functions.elementCreater("ul", "", {
                class: "accordian-items-third bold"
            });
            for (let e = 0; e < info[i].length; e++) {
                let item = functions.elementCreater("li", "", {
                    class: "accordian-item-third"
                });
                let content = functions.elementCreater("span", info[i][e], {
                    class: "item-third-content"
                });
                item.appendChild(content);
                list.appendChild(item);
            }
            listsContainer.appendChild(list);
        }

        container.appendChild(listsContainer);
    });

    //functions.fixPictures();
};

const init = () => {
    run();
}

init();